import { EventsBySportIdRequest } from "sb-bff-integration";
export const mapEventIcons = (x) => {
    x.livestreamIcon = { active: checkAvailability(x.tags.indexOf(EventsBySportIdRequest.EventTagsEnum.LiveStreaming.toString())), tooltip: "LiveStream" };
    x.fastmarketIcon = { active: checkAvailability(x.tags.indexOf(EventsBySportIdRequest.EventTagsEnum.FastMarket.toString())), tooltip: "FastMarket" };
    x.pulsebetIcon = { active: checkAvailability(x.tags.indexOf("Pulse")), tooltip: "PulseBet" };
    return x;
};
const checkAvailability = (index) => index === -1 ? false : true;
//# sourceMappingURL=mapEventIcons.js.map